/**
 * Collection of design tokens for animation durations. These values determine the time taken for
 * motion-based interactions and effects. The values are in seconds.
 */ const motionDurations = {
    fast: 0.15,
    medium: 0.3,
    slow: 0.45,
    snaillike: 2
};

export { motionDurations };
//# sourceMappingURL=motion-durations.js.map
